/**
 * Tiny segmented bar showing "X of Y items published". Green when fully
 * published, amber when partial, grey when zero.
 *
 * Extracted verbatim from QuestionBanksPage.jsx during the Phase 5 refactor
 * (no behaviour change).
 */
export function PublishProgressChip({ total, published }) {
  if (total === 0) {
    return (
      <span
        className="inline-flex items-center gap-1.5 text-[10px] text-muted-foreground italic"
        data-testid="bank-empty-tag"
      >
        Empty bank
      </span>
    );
  }
  const tone = published === total
    ? 'bg-green-500'
    : published > 0
      ? 'bg-amber-500'
      : 'bg-muted-foreground/30';
  const segs = Math.min(total, 8); // cap at 8 dots so 50-item banks don't blow out the chip
  return (
    <span className="inline-flex items-center gap-1.5 text-[11px] text-muted-foreground" title={`${published} of ${total} items published`}>
      <span className="inline-flex gap-0.5">
        {Array.from({ length: segs }).map((_, i) => {
          // Map dot index back to the original total proportionally
          const dotPublishedThreshold = Math.ceil(((i + 1) / segs) * total);
          const filled = published >= dotPublishedThreshold;
          return (
            <span
              key={`dot-${i}`}
              className={`w-1.5 h-1.5 rounded-full ${filled ? tone : 'bg-muted-foreground/20'}`}
            />
          );
        })}
      </span>
      <span>{published} / {total}</span>
    </span>
  );
}
